import Handler from "../Handler";

class SitOutCancelHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processSitOutCancel(receivedData);
  }
}

export default SitOutCancelHandler;
